import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import { Checkbox } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import BlurModal from '../../../components/common/blur-modal';
import { DOCSIGN_CONSTANTS } from '../../../constants';
import AcceptSignConfirmModal from './accept-sign-confirm-modal';
import Loading from '../../../components/common/loading/loading-circle';

class AcceptandSignModal extends PureComponent {
  constructor() {
    super();
    this.state = {
      acceptSignModalVisible: true,
      showConfirmationModal: false,
      confirmTitle: '',
      confirmationString: '',
      onConfirmFunc: () => { },
      enableButtons: false,
      base64Received: false,
      actionInProgress: false,
    };
    this.enableButtons = this.enableButtons.bind(this);
    this.acceptClicked = this.acceptClicked.bind(this);
    this.rejectClicked = this.rejectClicked.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.pdfPageChanged = this.pdfPageChanged.bind(this);
    this.closeConfirmModal = this.closeConfirmModal.bind(this);
    this.acceptConfirmed = this.acceptConfirmed.bind(this);
    this.rejectConfirmed = this.rejectConfirmed.bind(this);
    this.downloadDocument = this.downloadDocument.bind(this);
  }

  componentWillMount() {
    const {
      document,
    } = this.props;
    if (document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION || document.signStatus === 'Pending') {
      this.props.downloadDocument(document.dwoDocSid, document.docName);
    } else {
      this.props.getSignedDocument(document.dwoDocSid);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION || this.props.document.signStatus === 'Pending') {
      if (prevProps.acceptsign.acceptViewResponse !== this.props.acceptsign.acceptViewResponse) {
        this.setState({ base64Received: true });
      }
      if (prevProps.acceptsign.actionAcceptResponse !== this.props.acceptsign.actionAcceptResponse || prevProps.acceptsign.numOfActionCalls !== this.props.acceptsign.numOfActionCalls) {
        this.setState({ actionInProgress: false });
      }
    } else if (prevProps.docusignaccept.signedDocumentResponse !== this.props.docusignaccept.signedDocumentResponse) {
      this.setState({ base64Received: true })
    }
  }

  componentWillUnmount() {
    this.props.setActionAcceptResponseError('');
    this.props.setSignedDocumentResponseError('');
    this.props.setAcceptViewResponseError('');
  }

  enableButtons() {
    this.setState({ enableButtons: !this.state.enableButtons });
  }

  acceptClicked() {
    const {
      i18n: { messages },
    } = this.props;

    this.setState({
      showConfirmationModal: true,
      confirmTitle: messages['app.docsign.esignAcceptance.confirmTitle'],
      confirmationString: messages['app.docsign.esignAcceptance.confirmText'],
      onConfirmFunc: this.acceptConfirmed
    });
  }

  rejectClicked() {
    const {
      i18n: { messages }
    } = this.props;

    this.setState({
      showConfirmationModal: true,
      confirmTitle: messages['app.docsign.esignRejection.confirmTitle'],
      confirmationString: messages['app.docsign.esignRejection.confirmText'],
      onConfirmFunc: this.rejectConfirmed
    });
  }

  async closeModal() {
    if (this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION ||
      this.props.document.signStatus === 'Pending') {
      const { acceptsign: { acceptViewResponse, acceptViewResponseError } } = this.props;
      if (!acceptViewResponseError && acceptViewResponse) {
        await this.props.getActionAccept(acceptViewResponse.data.txId, DOCSIGN_CONSTANTS.CANCEL, this.props.document.docName);
      }
      this.props.docsign.setShowAcceptSignModal(false);
    } else {
      // this.props.updateShouldRefreshhDocumentList(true);
      this.props.docsign.setShowAcceptSignModal(false);
    }

    this.props.changePage('/portfolios', true);
    this.props.changePage('/docsign/document-list');
  }

  acceptConfirmed() {
    const { acceptsign: { acceptViewResponse } } = this.props;
    this.setState({
      // showConfirmationModal: false,
      actionInProgress: true
    });
    this.props.getActionAccept(acceptViewResponse.data.txId, DOCSIGN_CONSTANTS.ACCEPT);
  }

  rejectConfirmed() {
    this.setState({
      showConfirmationModal: false,
      actionInProgress: true
    });
    this.props.changePage('/docsign/accept-sign-reject');
  }

  closeConfirmModal() {
    this.setState({
      showConfirmationModal: false
    })
  }

  pdfPageChanged(page, numberOfPages) {
    if (page === numberOfPages) {
      this.setState({
        allPagesRead: true
      })
    }
  }

  downloadDocument(document) {
    this.props.downloadDocument(document.dwoDocSid, document.docName);
  }

  render() {
    const { enableButtons, base64Received, actionInProgress } = this.state;
    const {
      i18n: { messages },
      document,
      acceptsign: { acceptViewResponseError },
      docusignaccept: { signedDocumentResponseError }
    } = this.props;

    const isAPendingDocument = this.props.document.signStatus === DOCSIGN_CONSTANTS.PENDING_ACTION || this.props.document.signStatus === 'Pending';

    let loadingText = messages['app.docusign.digisign.downloadingDocument'];
    if (actionInProgress) {
      loadingText = messages['app.docusign.digisign.processinfo'];
    }

    if (!base64Received || actionInProgress || signedDocumentResponseError || acceptViewResponseError) {
      return (
        <BlurModal
          visible
          backVisible
          doneVisible={false}
          onBackPress={this.closeModal}
          title={document.docName}
          onDone={this.closeModal}
          size='large'
        >
          <div className="padding-top-50 padding-bottom-50">
            {acceptViewResponseError !== '' && acceptViewResponseError !== undefined && acceptViewResponseError !== null &&
              <Text className="center-content" secondary>{acceptViewResponseError}</Text>
            }
            {signedDocumentResponseError !== '' && signedDocumentResponseError !== undefined && signedDocumentResponseError !== null &&
              <Text className="center-content" secondary>{signedDocumentResponseError}</Text>
            }
            {!acceptViewResponseError && !signedDocumentResponseError &&
              <div>
                <Loading />
                <Text className="center-content" secondary>{loadingText}</Text>
              </div>
            }
          </div>
        </BlurModal>
      )
    }

    return (
      <BlurModal
        visible={isAPendingDocument}
        backVisible
        doneVisible={false}
        title={messages['app.docsign.esignAcceptance.headerTitle']}
        onDone={this.closeModal}
        headerChildren={
          <div className="row text-indent">
            <Checkbox className="pad-right-10" onChange={this.enableButtons} />
            <Text secondary>
              {' '}
              {messages['app.docsign.esignAcceptance.agreementText']}
              <a className="pointer" onClick={() => this.downloadDocument(document)} secondary>{document.docName}</a>
            </Text>
          </div>
        }
      >
        <div className="row padding-top-50 margin-top-30">
          <div className="columns large-3 large-push-5 medium-3 medium-push-6 small-6">
            <Button tertiary fullWidth onPress={this.rejectClicked}>
              {messages['app.docsign.rejectsign.button']}
            </Button>
          </div>
          <div className="columns large-4 medium-3 small-6">
            {enableButtons ?
              <Button fullWidth onPress={this.acceptClicked}>
                {messages['app.docsign.acceptandsign.button']}
              </Button>
              :
              <Button tertiary disabled fullWidth>
                {messages['app.docsign.acceptandsign.button']}
              </Button>
            }
          </div>
        </div>
        {this.state.showConfirmationModal &&
          <AcceptSignConfirmModal
            title={this.state.confirmTitle}
            confirmationString={this.state.confirmationString}
            onClose={this.closeConfirmModal}
            onConfirm={this.state.onConfirmFunc}
          />
        }
      </BlurModal>
    )
  }
}

export default createContainer({
  $queries: {
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    rsa: {
      onChangePage: {
        $call: 'changePage',
      },
    },
    setRsaPageName: { $set: 'ui.state.rsaPageName' },
    docsign: {
      setShowAcceptSignModal: { $set: 'showAcceptSignModal' }
    },
    acceptsign: {
      acceptViewResponse: true,
      actionAcceptResponse: true,
      acceptViewResponseError: true,
      actionAcceptResponseError: true
    },
    docusignaccept: {
      signedDocumentResponse: true,
      signedDocumentResponseError: true
    },
    getSignedDocument: { $call: 'docusignaccept.getSignedDocument' },
    downloadDocument: { $call: 'acceptsign.getAcceptView' },
    getAcceptView: { $call: 'acceptsign.getAcceptView' },
    getActionAccept: { $call: 'acceptsign.getActionAccept' },
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
          width: true,
          height: true,
        },
      }
    },
    setSignedDocumentResponseError: { $set: 'docusignaccept.signedDocumentResponseError' },
    setActionAcceptResponseError: { $set: 'acceptsign.actionAcceptResponseError' },
    setAcceptViewResponseError: { $set: 'acceptsign.acceptViewResponseError' }
  },
})(AcceptandSignModal);
